import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { Users, UserCheck, UserX, Wallet, Send, Activity, ShieldAlert, Mail } from 'lucide-react';
import { useLanguage } from '../../lib/LanguageContext';

function Stat({ icon: Icon, label, value, color = 'blue' }) {
  const colors = { blue: 'bg-blue-50 text-blue-700', emerald: 'bg-emerald-50 text-emerald-700', amber: 'bg-amber-50 text-amber-700', rose: 'bg-rose-50 text-rose-700', slate: 'bg-slate-100 text-slate-700' };
  return (
    <div className="stat-card flex items-start gap-4">
      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${colors[color]}`}><Icon className="w-5 h-5"/></div>
      <div>
        <div className="text-slate-500 text-xs uppercase font-medium">{label}</div>
        <div className="text-2xl font-bold mt-0.5">{value}</div>
      </div>
    </div>
  );
}

export default function AdminOverview() {
  const { t } = useLanguage();
  const [data, setData] = useState(null);
  useEffect(() => { (async () => {
    const r = await api.get('/admin/overview');
    setData(r.data);
  })(); }, []);
  if (!data) return <div>{t('common.loading')}</div>;
  const s = data.stats;
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">{t('admin.nav.overview')}</h1>
        <p className="text-slate-500 text-sm">{t('admin.overviewSubtitle')}</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat icon={Users} label={t('admin.totalClients')} value={s.total_clients} />
        <Stat icon={UserCheck} label={t('admin.activeAccounts')} value={s.actifs} color="emerald"/>
        <Stat icon={UserX} label={t('admin.pending')} value={s.en_attente} color="amber"/>
        <Stat icon={ShieldAlert} label={t('admin.blocked')} value={s.bloques} color="rose"/>
        <Stat icon={Wallet} label={t('admin.totalDeposits')} value={`${s.total_depots.toLocaleString('fr-FR')} €`} color="emerald"/>
        <Stat icon={Send} label={t('admin.pendingTransfers')} value={s.virements_attente} color="amber"/>
        <Stat icon={Activity} label={t('admin.transfersToday')} value={s.virements_today} />
        <Stat icon={Mail} label={t('admin.otpSentToday')} value={s.otp_envoyes_today} />
      </div>
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-2xl border border-slate-200 p-6">
          <h2 className="font-semibold mb-3">{t('admin.lastInscriptions')}</h2>
          <div className="divide-y">
            {data.last_inscriptions.map((u) => (
              <div key={u.id} className="py-2 flex justify-between text-sm">
                <div><div className="font-medium">{u.prenom} {u.nom}</div><div className="text-xs text-slate-500">{u.email}</div></div>
                <div className="text-xs text-slate-500">{u.statut_compte}</div>
              </div>
            ))}
            {data.last_inscriptions.length === 0 && <div className="text-slate-500 text-sm py-3">{t('admin.none')}</div>}
          </div>
        </div>
        <div className="bg-white rounded-2xl border border-slate-200 p-6">
          <h2 className="font-semibold mb-3">{t('admin.lastTransfers')}</h2>
          <div className="divide-y">
            {data.last_transfers.map((tr) => (
              <div key={tr.id} className="py-2 flex justify-between text-sm">
                <div><div className="font-medium">{tr.beneficiaire_nom}</div><div className="text-xs text-slate-500">{tr.user_email}</div></div>
                <div className="text-right"><div className="font-bold">{tr.montant.toLocaleString('fr-FR')} €</div><div className="text-xs text-slate-500">{tr.statut}</div></div>
              </div>
            ))}
            {data.last_transfers.length === 0 && <div className="text-slate-500 text-sm py-3">{t('admin.noneMasc')}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
